// NPM Imports
// Quote Context
// Component Imports
// JS Imports
// Asset Imports
// Variables
const referrer = document.referrer

export default function NoPricebooksAssigned() {
   if (
      referrer.includes('force.com') ||
      referrer.includes('quote.bamboohr.net') ||
      referrer.includes('stage.quote.bamboohr.net')
   )
      return (
         <div
            className='h-100 d-flex align-items-center justify-content-center'
            id='NoPricebooksAssigned'
         >
            You have not been assigned any pricebooks. If you believe this is an
            error, please&nbsp;
            <a
               target='_blank'
               href='https://bamboohr.atlassian.net/servicedesk/customer/portal/9'
            >
               submit a ticket.
            </a>
         </div>
      )
   else
      return (
         <div
            className='h-100 d-flex align-items-center justify-content-center'
            id='NoPricebooksAssigned'
         >
            No pricebooks available.
         </div>
      )
}
